import { render, staticRenderFns } from "./base-tabs.vue?vue&type=template&id=a4102470&scoped=true&"
import script from "./base-tabs.vue?vue&type=script&lang=js&"
export * from "./base-tabs.vue?vue&type=script&lang=js&"
import style0 from "./base-tabs.vue?vue&type=style&index=0&id=a4102470&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4102470",
  null
  
)

export default component.exports